module.exports = __webpack_public_path__ + "img/cpeos.9cb84625.png";